import { z } from 'zod';
import { isoDateTime } from './common.js';
/** One person, for both doors: the bot (Telegram id) and the panel (email). */
export const userRoleSchema = z.enum(['admin', 'dispatcher', 'viewer']);
export const userChannelSchema = z.enum(['telegram', 'web']);
export const appUserSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string().optional(),
    telegramId: z.string().optional(),
    telegramUsername: z.string().optional(),
    role: userRoleSchema,
    channels: z.array(userChannelSchema),
    enabled: z.boolean(),
    /**
     * The source ids (`samsara:acme`) this person may read. Absent: every source,
     * including ones connected later. Admins always read every source.
     */
    sourceAccess: z.array(z.string()).optional(),
    lastSeenAt: isoDateTime.optional(),
    addedBy: z.object({ id: z.uuid(), name: z.string() }).optional(),
    createdAt: isoDateTime,
});
//# sourceMappingURL=users.js.map